
import Vue from 'vue'
import Drift from 'drift-zoom'
import { mapActions, mapGetters } from 'vuex'
import eventBus from '@/utils/eventBus'
import { APP_EVENTS } from '@/constants'
import Lottie, { AnimationItem } from 'lottie-web'

export default Vue.extend({
  props: {
    imageUrl: {
      type: String,
      required: true
    },
    imageDescription: {
      type: String,
      required: true
    }
  },
  data(): {
    animation: AnimationItem | null
  } {
  return {
      animation: null
    }
  },
  computed: {
    ...mapGetters([
      'product',
      'estimate',
      'estimateQuantity',
      'quantities',
      'favoritesCount',
      'addedToEstimate'
    ]),
    favoriteButtonText() {
      return this.addedToEstimate ? 'Added to favorites' : 'Add to favorites'
    },
    psi() {
      return this.product.printable_sku_id
    }
  },
  watch: {
    psi() {
      this.controlAnimation()
    }
  },
  mounted() {
    this.renderFavoriteButton()

    try {
      new Drift(this.$el.getElementsByClassName('sliderImage')[0], {
        paneContainer: this.$el.getElementsByClassName('pr-ActiveImage_ZoomPaneContainer')[0],
        zoomFactor: 3,
        hoverDelay: 500,
        hoverBoundingBox: true
      })
    } catch (e) {}
  },
  destroyed() {
    if (this.animation) {
      this.animation.destroy()
      this.animation = null
    }
  },
  methods: {
    ...mapActions([
      'addToEstimate',
      'removeFromEstimate'
    ]),
    async onClickFavoriteButton() {
      if (this.addedToEstimate) {
        await this.onRemoveFromFavorite()
      } else {
        await this.onAddToFavorite()
      }
    },
    async onAddToFavorite() {
      await this.addToEstimate({
        quantity: this.quantities.quantity,
        trial: this.estimate.trial,
        printable_sku_id: this.estimate.printable_sku_id,
        sku_printable_special_color_ids: this.product.sku_printable_special_colors,
        sku_printable_cmyk_color_ids: this.product.sku_printable_cmyk_colors
      })
      this.animation.playSegments([0, 40], true)
      eventBus.$emit(APP_EVENTS.UPDATE_FAVORITES_COUNT_BADGE, this.favoritesCount)
    },
    async onRemoveFromFavorite() {
      await this.removeFromEstimate(this.product.estimate_item_id)
      this.animation.goToAndStop(5, true)
      eventBus.$emit(APP_EVENTS.UPDATE_FAVORITES_COUNT_BADGE, this.favoritesCount)
    },
    renderFavoriteButton() {
      this.animation = Lottie.loadAnimation({
        container: this.$refs.favoriteButton,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: require('product/animation/fav-btn.txt')
      })

      this.controlAnimation()
    },
    controlAnimation() {
      if (this.addedToEstimate) {
        this.animation.goToAndStop(28, true)
      } else {
        this.animation.goToAndStop(5, true)
      }
    }
  }
})
